export const REGISTER = {
    REQUEST_REGISTRATION: "REQUEST_REGISTRATION",
    SUCCESS_REGISTRATION: "SUCCESS_REGISTRATION",
    FAILED_REGISTRATION: "FAILED_REGISTRATION",
}